import { useState } from "react";
import { Button, Flex, Input, Modal } from "src/elements";
import { useNewCdtNodeModal } from "./store/hooks";

export const ModalNewCdtNode = () => {
  const { newCdtNodeData, setNewCdtNodeValue } = useNewCdtNodeModal();
  const [cdtValue, setCdtValue] = useState("");

  if (newCdtNodeData === null) {
    return null;
  }

  return (
    <Modal
      name="ModalNewCdtNode"
      width="300px"
      title={
        "Add New CDT" +
        ((newCdtNodeData.cdtLevel === "variant" && " Variant") ||
          (newCdtNodeData.cdtLevel === "cdt1" && "-1") ||
          (newCdtNodeData.cdtLevel === "cdt2" && "-2") ||
          (newCdtNodeData.cdtLevel === "cdt3" && "-3") ||
          "") +
        " Node"
      }
    >
      <Flex padding="10px" gap="10px">
        <Input value={cdtValue} setValue={setCdtValue} />

        <Button onClick={() => setNewCdtNodeValue(newCdtNodeData.cdtLevel, cdtValue)}>Add</Button>
      </Flex>
    </Modal>
  );
};
